export default __webpack_public_path__ + "static/media/smoking.ecd278a4.svg";